// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"ResponsiveImage_mobileOnly__HaHwR","desktopOnly":"ResponsiveImage_desktopOnly__EY_wt"};